var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"menu-chip-container"},[_c('v-chip',{staticClass:"menu-chip",attrs:{"x-small":"","color":_vm.chip_color,"text-color":_vm.text_color,"outlined":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }